import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import PointCauseListContainer from '../../containers/point/PointCauseListContainer';
import { POINT_PAGE_NAME } from '../../constants/service/app/pointConstants';

const PointCauseList = () => {
  return (
    <PageTemplate pageName={POINT_PAGE_NAME.POINT_CAUSE_LIST}>
      <PointCauseListContainer />
    </PageTemplate>
  );
};

export default PointCauseList;
